module.exports = "/fast-coin/img/coin/coin_dice_2.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/coin_dice_2.png
// module id = 2379
// module chunks = 5